import React, { Component } from "react";
import { connect } from "react-redux";

const origin = window.location.origin;

function messageListener(event) {
  if (event.origin !== origin || event.data.source !== "ingdesk") return;

  if (event.data.id === "reminder") {
    // setNotifications((oldState) => [...oldState, event.data.payload]);
  }
}

const mapStateToProps = (state) => {
  return {
    InfoUsers: state.informationusers,
  };
};

class BrowserComms extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: "" };
  }

  // componentDidMount(){
  //     window.addEventListener('message', message => {
  //         if (message.source !== iframeRef.current || message.data.origin !== 'ingdesk')
  //             return

  //         console.debug('(INGWEB) MESSAGE RECEIVED FROM INGDESK: ', message.data);
  //     })
  // }

  render() {
    const { InfoUsers } = this.props;

    return <div style={{ position: "absolute" }} />;
  }
}

export default connect(mapStateToProps, null)(BrowserComms);
